var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OnboardingStepper',{attrs:{"stepper-config":_vm.stepperConfig,"step":_vm.getCurrentStep,"state":_vm.state,"loading":_vm.loading},on:{"on-next":_vm.onNext,"on-back":_vm.onBack,"update-form-value":_vm.onUpdateFormValue}})}
var staticRenderFns = []

export { render, staticRenderFns }